import { render, staticRenderFns } from "./CRUDFeriados.vue?vue&type=template&id=4e5195aa&scoped=true&"
import script from "./CRUDFeriados.vue?vue&type=script&lang=js&"
export * from "./CRUDFeriados.vue?vue&type=script&lang=js&"
import style0 from "./CRUDFeriados.vue?vue&type=style&index=0&id=4e5195aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5195aa",
  null
  
)

export default component.exports